export enum RatingSize {
  L = 'l',
  S = 's',
}
